/** Ödenmemiş late fee (assessed − paid). */
export const getRemainingLateFeeDue = (item) => {
  const assessed = Number(item?.late_fee ?? item?.lateFee ?? 0);
  const paid = Number(item?.late_fee_paid ?? 0);
  return Math.max(0, assessed - paid);
};

export const getSchedulePaymentAmount = (item) =>
  Number(item?.pmt_amount ?? item?.amount ?? item?.payment_amount ?? 0);

export const getScheduleTotalDue = (item) => {
  const explicit = item?.total_due ?? item?.totalDue;
  if (explicit != null && explicit !== "") return Number(explicit);
  return getSchedulePaymentAmount(item) + getRemainingLateFeeDue(item);
};
